<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="contents-wrapper">
    <div class="contents-container">
      <div class="page-icon">
        <img src="/assets/icon/Saving-Piggy-Coins-Alternate.svg" alt="" />
      </div>

      <div class="page-text">Et siste lite spørsmål...</div>

      <div class="page-sub-text">Hva er din månedlige inntekt etter skatt?</div>

      <zaver-list-slider
        class="input"
        *ngIf="sliderAsInput"
        [ariaLabel]="'Månedlige inntekt'"
        [listOptions]="sliderSalaryAnswers"
        [initialValue]="sliderSalaryAnswers[4]"
        [(value)]="sliderAnswer"
      ></zaver-list-slider>

      <form [formGroup]="form" id="form" class="input">
        <zaver-animated-form-input
          *ngIf="!sliderAsInput"
          [placeholder]="'Månedlige inntekt'"
          [errorMessage]="'Kun tall tillatt'"
          [formControlName]="'formAnswer'"
          [size]="'large'"
          [showContent]="true"
          (onKeyboardEnter)="handleCtaClick()"
          [error]="form.controls.formAnswer.invalid && showError"
          [errorIcon]="'assets/icon/icon_error.svg'"
        >
          <span class="currency-text">
            NOK
          </span>
        </zaver-animated-form-input>
      </form>

      <div class="page-sub-text">
        <a
          *ngIf="!hideSlider"
          [routerLink]=""
          queryParamsHandling="preserve"
          (click)="toggleInput()"
        >
          {{
            sliderAsInput
              ? 'Skriv inn det nøyaktige beløpet i stedet'
              : 'Velg heller på en skala'
          }}
        </a>
      </div>

      <div class="pr-info">
        <label>Totalbeløp</label>
        <label>
          {{ state.totalCheckoutValue | value }}
        </label>
      </div>
      <zaver-primary-button
        [text]="'Neste'"
        (click)="handleCtaClick()"
        [loading]="navigationInProgress"
      >
      </zaver-primary-button>
    </div>
  </div>
</div>
